import { render, staticRenderFns } from "./ExerciseInsightsTrendChart.vue?vue&type=template&id=6bcd8765"
import script from "./ExerciseInsightsTrendChart.vue?vue&type=script&lang=js"
export * from "./ExerciseInsightsTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports